// Components==============
import Avatar from 'components/UI/Avatar/Avatar';
import { motion } from 'framer-motion';
import { useProcessGroups } from 'hooks/useProcessGroups';
import { useRedux } from 'hooks/useRedux';
import { useTranslate } from 'hooks/useTranslate';
import React from 'react';
import { useHistory } from 'react-router';
import './Reflection.module.scss';
// =========================

export default function Card({
  item,
  first,
  placeholder,
}: {
  item?: ReflectionEntity;
  first?: boolean;
  placeholder?: boolean;
}) {
  const history = useHistory();
  const translate = useTranslate();

  const framer = {
    initial: { rotateY: 0, opacity: 0 },
    animate: {
      rotateY: first ? 8 : 11,
      opacity: 1,
    },
    whileHover: { rotateY: 0 },
    whileTap: { rotateY: 0, scale: 0.97 },
  };

  const date = item?.updated_at
    ? new Date(item?.updated_at?.split(' ')[0]).toLocaleDateString('nl')
    : null;

  const project = useRedux((state) =>
    item?.project_process?.process_id
      ? state.project?.entities.byId[item.project_process.project_id]
      : undefined
  );

  const { processGroups } = useProcessGroups(project);

  const endPoint = processGroups?.find(
    (group) => group.id === 7 && group.process_type === 'App\\Phase'
  )?.processId;

  const handleClick = () => {
    if (placeholder || !!project?.locked_for_assessment)
      return history.push('/groei/mijn-reflecties');

    history.push(
      `/groei/reflecteren/${item?.project_process?.project?.id}/${endPoint}`
    );
  };

  return (
    <motion.div
      {...framer}
      styleName={`card ${first ? 'first' : ''} ${
        placeholder ? 'placeholder' : ''
      } `}
      onClick={handleClick}
    >
      <div styleName="avatar">
        {placeholder ? (
          <img src="/images/groowy.svg" alt="groowy" />
        ) : (
          <Avatar user={item?.user} size="medium-big" border />
        )}
      </div>
      <span>{date}</span>
      <h2>
        {placeholder
          ? 'Groowy'
          : `${item?.user.first_name} ${item?.user.last_name}`}
      </h2>
      <p>
        {placeholder
          ? translate('reflection.not-receive-reflection')
          : item?.note?.[0]?.answer}
      </p>
    </motion.div>
  );
}
